import React from 'react'

interface PremiumCardProps {
  children: React.ReactNode
  className?: string
  hover?: boolean
  gradient?: boolean
}

export default function PremiumCard({ children, className = '', hover = true, gradient = false }: PremiumCardProps) {
  const baseStyles = 'relative overflow-hidden transition-all duration-500'

  const hoverStyles = hover ? 'hover:-translate-y-1 hover:shadow-2xl cursor-pointer' : ''

  const backgroundStyles = gradient ? 'bg-gradient-to-br from-white to-gray-50' : 'bg-white'

  return (
    <div
      className={`${baseStyles} ${hoverStyles} ${backgroundStyles} ${className} rounded-3xl shadow-md border border-gray-100`}
    >
      {gradient && (
        <div className="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-500 pointer-events-none">
          <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-orange-100 to-transparent blur-2xl"></div>
        </div>
      )}
      <div className="relative z-10">{children}</div>
    </div>
  )
}
